import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyDto,
  PageableListV2Dto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';
import { ExternalApiKey, ExternalCompanyApiKey } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class TrackingSettingsApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/external/api-keys`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getMany(params: GetManyDto, auth: AuthHeaders): Observable<PageableListV2Dto<ExternalCompanyApiKey>> {
    return this.baseApiService.get(this.baseUrl, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ExternalCompanyApiKey[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<ExternalCompanyApiKey[]>) => {
        return {
          ...response,
          ...response.meta,
        };
      }),
    );
  }

  postOne(data: ExternalApiKey, auth: AuthHeaders): Observable<ExternalCompanyApiKey> {
    return this.baseApiService.post(this.baseUrl, data, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ExternalCompanyApiKey>) => this.baseApiService.mapResponse(response)),
    );
  }

  patchOne(id: string, data: ExternalApiKey, auth: AuthHeaders): Observable<ExternalCompanyApiKey> {
    return this.baseApiService.patch(`${this.baseUrl}/${id}`, data, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ExternalCompanyApiKey>) => this.baseApiService.mapResponse(response)),
    );
  }

  deleteOne(id: string, auth: AuthHeaders): Observable<ExternalCompanyApiKey> {
    return this.baseApiService.delete(`${this.baseUrl}/${id}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<ExternalCompanyApiKey>) => this.baseApiService.mapResponse(response)),
    );
  }
}
